import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { BatchManualClaimTypes } from "@/types";

export interface BatchManualClaimListState {
  batchManualClaimListResults: {
    results: Array<BatchManualClaimTypes.BatchManualClaim>;
    result_count: string;
  };
}

const DEFAULT_GET_MANUAL_CLAIM_LIST_STATE: BatchManualClaimListState = {
  batchManualClaimListResults: {
    results: [],
    result_count: "0",
  },
};

export default (state: BatchManualClaimListState = DEFAULT_GET_MANUAL_CLAIM_LIST_STATE, action: Action): BatchManualClaimListState => {
  if (action.type === ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST_RESULTS) {
    return {
      ...state,
      batchManualClaimListResults: action.payload,
    };
  } else {
    return state;
  }
};
